import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'comment-component',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './comment.component.html',
  styleUrl: './comment.component.css'
})
export class CommentComponent {

  @Input() data: any;
  @Input() config: any;
  newComment = '';
  comments: { [key: string]: string[] } = {}; 
  activeEventId: string | null = null; 

  @ViewChild('commentBox', { static: false }) view!: ElementRef;
  constructor(private viewContainer: ViewContainerRef) {}

  ngOnInit(): void {
    try {
      this.data = typeof this.data === 'string' ? JSON.parse(this.data) : this.data;
      this.config = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
    } catch (error) {
      console.error("Error parsing input data/config:", error);
    }
    console.log("get comment data", this.getComments())
    this.getComments();
  }

  getComments() {
    const customEvent = new CustomEvent('requestData', {
      bubbles: true,
      cancelable: true,
      detail: {
        data: {
          dataModel: 'ratings', 
          dataParams: this.data,
        },
      },
    });

    this.viewContainer.element.nativeElement.dispatchEvent(customEvent);

    const responseHandler = (event: any) => {
      console.log('event', event);
      const ratings = this.data?.data?.ratings; 
      this.comments[ratings] = event.detail?.data?.comments || [];
    };

    this.view.nativeElement.addEventListener('responseData', responseHandler);
  }

  postComment(event: any) {
    event.preventDefault();

    if (this.newComment.trim() && this.activeEventId) {
      if (!this.comments[this.activeEventId]) {
        this.comments[this.activeEventId] = [];
      }
      this.comments[this.activeEventId].push(this.newComment);
      this.newComment = '';
    }
  }

  openCommentBox(ratings: string) {
    this.activeEventId = ratings;
  }
}
